import { FC } from 'react';

import ConfirmButton from 'primitives/ConfirmButton';

const PassFundDialogButton: FC<{
  fundId?: string;
}> = ({ fundId }) => {
  return (
    <ConfirmButton
      className="w-full h-full"
      onConfirm={() => {
        alert('Pass Fund');
      }}
      title="Pass Deal"
      description="Are you sure you want to pass on this deal? You will have to contact the syndicate lead if you want to invest later."
      variant="secondary"
    >
      Pass Fund
    </ConfirmButton>
  );
};

export default PassFundDialogButton;
